<template>
  <div class="row mb-4">
    <div class="col">
      <div class="mt-2">
        <!-- HELPER -->
        <span v-if="blockData.settings && blockData.settings.helper" class="d-block text-muted mb-2">
          <small>{{ blockData.settings.helper }}</small>
        </span>

        <!-- CONTROLS -->
        <div class="row">
          <div class="col flex-grow-1 d-flex">
            <div>
              <LoadingButton v-if="showSaveButton" @click.native="$emit('save')" :loading="saving" class="btn btn-success mr-1" :disabled="!changed">{{ saveButtonLabel }}</LoadingButton>
              <button @click="cancel" class="btn btn-secondary mr-3">{{ cancelButtonLabel }}</button>
              <button @click="versions = !versions" class="btn btn-secondary mr-1" :class="{ active: versions }">Version History</button>
            </div>

            <div class="ml-auto">
              <Approve v-if="!changed" @approve="approve" :block="blockData" :withCounterparty="state.withCounterparty" :approving="approving"/>
            </div>
          </div>
        </div>

        <Meta :block="blockData" :state="state" />
        <Versions v-if="versions" :versions="blockData.versions" :type="block.type"/>
      </div>
    </div>
  </div>
</template>

<script>

import helpers from '@/Mixins/helpers';
import contractState from '@/Mixins/contractState';
import LoadingButton from '@/Shared/LoadingButton';
import Versions from '@/Pages/Asset/Contract/Versions/Versions';
import Meta from './Meta';
import Approve from './Approve';

export default {
  mixins: [helpers, contractState],

  components: {
    LoadingButton,
    Versions,
    Meta,
    Approve,
  },

  props: {
    assetId: String,
    model: String,

    block: Object,
    saving: Boolean,

    saveButtonLabel: {
      type: String,
      default: 'Save',
    },
    cancelButtonLabel: {
      type: String,
      default: 'Cancel',
    },

    parentComponent: {
      type: Boolean,
      default: false,
    },

    changed: Boolean,
  },

  data() {
    return {
      blockData: this.block,
      approving: false,
      versions: false,
      comments: false,
    };
  },

  watch: {
    block(value) {
      this.blockData = value;
    },
  },

  computed: {
    showSaveButton() {
      // This is a parent component (i.e. expanable list or table)
      // and doesn't have anything to 'save' as the saving is done
      // on the child components
      if (this.parentComponent) {
        return false;
      }

      // States you need to be a Contract Lead:
      let showForStates = [
        'editing',
        'approved',
        'signed',
        'executed',
      ];

      if (showForStates.includes(this.state.state)) {
        return this.userHasRole('contract_lead');
      }

      // States you need to be an Approver
      showForStates = [
        'pending',
      ];

      if (showForStates.includes(this.state.state)) {
        return this.userHasRole('approver');
      }

      return false;
    },

  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    approve() {
      this.approving = true;

      let endpoint = '';

      if (this.blockData.state === 'pending' || this.blockData.state === 'incomplete') {
        endpoint = `/contract-block/${this.block.id}/approve`;
      }

      if (this.blockData.state === 'originatorApproved' || this.blockData.state === 'counterpartyApproved') {
        endpoint = `/contract-block/${this.block.id}/accept`;
      }

      window.axios
        .put(endpoint)
        .then(({ data }) => {
          this.approving = false;
          this.blockData = data;
          this.fetchAssetState(this.assetId);
          this.$emit('updated', data);
          this.$emit('cancel');
        })
        .catch((error) => {
          this.approving = false;
          this.errors = error.response.data.errors;
          throw new Error(error);
        });
    },
  },
};
</script>
